import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import DataTable from "../DataTable/DataTable";
import { getUsedDetails } from "../../services/apiService";
import LoaderWithBackdrop from "../Loader/loader";


function Receipts() {
  const userId = localStorage.getItem("userId") || "";
  const [receiptsDetails, setReceiptsDetails] = React.useState([]);
  const [page, setPage] = React.useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(25);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [totalCount, setTotalCount] = React.useState<number>(0);



  // Fetch receipts details from the API
  const fetchReceiptsDetails = React.useCallback(async (page: number, rowsPerPage: number) => {
    setIsLoading(true);
    try {
      const response = await getUsedDetails('payments', userId, rowsPerPage, page + 1);
      setIsLoading(false);
      if (response && response.data) {
        setReceiptsDetails(response.data.data || []);
        setTotalCount(response.data.total || 0);
      } else {
        setReceiptsDetails([]);
      }
    } catch (error) {
      setIsLoading(false);
      setReceiptsDetails([]);
    }
  }, [userId]);
    React.useEffect(() => {
    fetchReceiptsDetails(page, rowsPerPage);
  }, [page, rowsPerPage, userId, fetchReceiptsDetails]);




  const columns = [
    { id: "date", label: "Date" },
    { id: "packname", label: "Pack Name" },
    { id: "creditpurchase", label: "Credit Purchased" },
    { id: "amount", label: "Amount" },
    {
      id: "status", label: "Status", isButton: true,
      buttonBgColor: '#54E324',
      buttonTextColor: '#54E324',
    },
    {
      id: "action", label: "Action", isButton: true,
      buttonBgColor: '#FFFFFF',
      buttonTextColor: '#ffffff',
      isIcon: true
    },
  ];

  const rows = receiptsDetails.map((item: any) => ({
    date: item.createdAt
      ? new Date(item.createdAt).toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }).replace(',', '')
        .replace(/(\d{2}:\d{2})/, (match) => match.replace(':', ':'))
      : '',
    packname: item.productName || '',
    creditpurchase: item.creditPoints || '',
    amount: (item.currency ? (item.currency.toUpperCase() === "INR" ? "₹" : "$") : "") + (item.totalAmount ?? ''),
    status:
      item.paymentStatus === "PAYMENT_SUCCESS" || item.paymentStatus === "paid" || item.paymentStatus === "captured"
        ? "Paid"
        : item.paymentStatus === "pending"
          ? "Pending"
          : item.paymentStatus === "failed"
            ? "Failed"
            : item.paymentStatus,
    action: item.receiptUrl ? 'Download' : '',
    receiptUrl: item.receiptUrl || '',
  }));


  // Pagination handlers
  const handleChangePage = (event: unknown, newPage: number) => {
    console.log("Page changed to:", newPage);
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Grid
  item
  xs={12}
  sx={{
    padding: {
      xs: 0,    
      sm: 2,     
    },
  }}
>      {isLoading && (<LoaderWithBackdrop open={isLoading} />)}
      <Box>
        <Typography variant="h1" gutterBottom className="studioNavHeading">My Receipts</Typography>
      </Box>
      <Box padding={2}>
        <DataTable
          columns={columns}
          rows={rows}
          count={totalCount}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Box>
    </Grid>
  );
}
export default Receipts;